{
  "version": 1,
  "asset_id": "40f2db8d-c313-43ff-a30a-de6028b5810c",
  "project_id": "e692c292-fbeb-41e1-8213-5a4529ec6f58",
  "url": "/__l5e/assets-v1/40f2db8d-c313-43ff-a30a-de6028b5810c/geovita.png",
  "r2_key": "a/v1/e692c292-fbeb-41e1-8213-5a4529ec6f58/40f2db8d-c313-43ff-a30a-de6028b5810c/geovita.png",
  "original_filename": "geovita.png",
  "size": 28610,
  "content_type": "image/png",
  "created_at": "2026-07-10T03:51:07Z"
}
